import {useQuery} from 'react-query';
import {getTakenDirectLoanDetails} from './getTakenDirectLoanDetails';

const useGetTakenDirectLoanDetails = (loanRequestGuid?: string) => {
  const {data, isLoading} = useQuery(
    ['get-taken-direct-loan-details', loanRequestGuid],
    () => getTakenDirectLoanDetails(loanRequestGuid),
    {
      enabled: Boolean(loanRequestGuid),
    },
  );

  return {data, isLoading};
};

export default useGetTakenDirectLoanDetails;
